import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class ClientInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const clientId = sessionStorage.getItem('client');
        console.log('[ClientInterceptor]', clientId);

        let secureReq = req.clone({
            headers: req.headers.set('X-Device-Context', 'asap_authorized_access')
        });

        // Não anexa client_id na rota de inicialização do dispositivo
        if (req.url.indexOf('device/init') === -1) {
            if (!secureReq.params.get("client_id")) {
                if ((clientId) && (clientId != "")) {
                    secureReq = secureReq.clone({
                        params: secureReq.params.append('client_id', clientId)
                    });
                }
            }
        }
        return next.handle(secureReq);
    }
}



// WEBPACK FOOTER //
// ./src/app/@core/interceptors/client-interceptor.ts